(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snout-cart"]) return;
  try {
    
  (function () {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
    function wrap() { return document.querySelector('[data-sn-cart]'); }
    function setCount(n) {
      document.querySelectorAll('[data-sn-cart-count]').forEach(function (el) { el.textContent = n > 99 ? '99+' : String(n); el.hidden = n === 0; });
    }
    function render(html) {
      var w = wrap(); if (!w || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-sn-cart-inner]');
      var cur = w.querySelector('[data-sn-cart-inner]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    }
    function showError(msg) { var el = wrap() && wrap().querySelector('[data-sn-cart-error]'); if (el) { el.textContent = msg; el.hidden = !msg; } }
    function request(url, body) {
      var w = wrap(); var id = w.getAttribute('data-section-id');
      w.classList.add('is-busy');
      body = body || {};
      body.sections = [id];
      body.sections_url = location.pathname;
      return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) { showError(res.json.description || res.json.message || 'Something went wrong. Please try again.'); return null; }
          if (res.json.sections) render(res.json.sections[id]);
          if (typeof res.json.item_count === 'number') setCount(res.json.item_count);
          document.dispatchEvent(new CustomEvent('snout:cart-changed', { detail: res.json }));
          return res.json;
        })
        .catch(function () { showError('Connection problem. Please try again.'); return null; })
        .finally(function () { w.classList.remove('is-busy'); });
    }
    function change(key, qty) { return request('cart/change.js', { id: key, quantity: Math.max(0, qty) }); }
    function refresh() {
      var w = wrap(); var id = w.getAttribute('data-section-id');
      return fetch(location.pathname + '?sections=' + encodeURIComponent(id)).then(function (r) { return r.json(); }).then(function (j) { render(j[id]); });
    }

    document.addEventListener('click', function (e) {
      if (!wrap()) return;
      var t = e.target;
      var step = t.closest('[data-sn-cart-step]');
      if (step) {
        var input = step.parentElement.querySelector('[data-sn-cart-qty]');
        change(step.getAttribute('data-key'), (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-sn-cart-step'), 10));
        return;
      }
      var rm = t.closest('[data-sn-cart-remove]');
      if (rm) { change(rm.getAttribute('data-sn-cart-remove'), 0); return; }
      if (t.closest('[data-sn-cart-clear]')) {
        var w = wrap(); w.classList.add('is-busy');
        fetch(root + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { setCount(c.item_count || 0); return refresh(); })
          .finally(function () { w.classList.remove('is-busy'); });
        return;
      }
      if (t.closest('[data-sn-discount-apply]')) {
        var field = wrap().querySelector('[data-sn-discount-input]');
        var code = field && field.value.trim();
        if (!code) { if (field) field.focus(); return; }
        var existing = Array.prototype.map.call(wrap().querySelectorAll('[data-sn-discount-remove]'), function (b) { return b.getAttribute('data-sn-discount-remove'); });
        var all = existing.filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); }).concat([code]).join(',');
        request('cart/update.js', { discount: all }).then(function (cart) {
          if (!cart) return;
          var found = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
          var msg = wrap().querySelector('[data-sn-discount-msg]');
          if (msg) {
            msg.hidden = false;
            msg.classList.toggle('is-ok', !!(found && found.applicable));
            msg.textContent = found && found.applicable ? 'Code applied.' : 'This code is not valid for your cart.';
          }
        });
        return;
      }
      var drm = t.closest('[data-sn-discount-remove]');
      if (drm) {
        var remove = drm.getAttribute('data-sn-discount-remove');
        var keep = Array.prototype.map.call(wrap().querySelectorAll('[data-sn-discount-remove]'), function (b) { return b.getAttribute('data-sn-discount-remove'); })
          .filter(function (c) { return c !== remove; }).join(',');
        request('cart/update.js', { discount: keep });
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest && e.target.closest('[data-sn-cart] [data-sn-cart-qty]');
      if (input) change(input.getAttribute('data-key'), parseInt(input.value, 10) || 0);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var field = e.target.closest && e.target.closest('[data-sn-cart] [data-sn-discount-input]');
      if (field) { e.preventDefault(); var b = wrap().querySelector('[data-sn-discount-apply]'); if (b) b.click(); }
      var qty = e.target.closest && e.target.closest('[data-sn-cart] [data-sn-cart-qty]');
      if (qty) { e.preventDefault(); qty.blur(); }
    });
    // Already on the cart page: the header bag opens this page instead of the drawer
    document.addEventListener('click', function (e) {
      if (!wrap()) return;
      var toggle = e.target.closest && e.target.closest('[data-sn-cart-toggle]');
      if (toggle) {
        e.stopPropagation(); e.preventDefault();
        var pw = document.querySelector('.page-wrapper');
        if (pw) pw.scrollTo({ top: 0, behavior: 'smooth' });
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snout-checkout"]) return;
  try {
    
  (function () {
    var API = '/api/2025-07/graphql.json';
    var PHONE_EXAMPLE = {
      US: '+1 212 555 0123', CA: '+1 416 555 0123', GB: '+44 7700 900123', IE: '+353 85 123 4567',
      AU: '+61 412 345 678', NZ: '+64 21 123 4567', DE: '+49 1512 3456789', FR: '+33 6 12 34 56 78',
      IT: '+39 312 345 6789', ES: '+34 612 34 56 78', NL: '+31 6 12345678', BE: '+32 470 12 34 56',
      AT: '+43 664 1234567', CH: '+41 78 123 45 67', PT: '+351 912 345 678', PL: '+48 512 345 678',
      CZ: '+420 601 123 456', SE: '+46 70 123 45 67', NO: '+47 406 12 345', DK: '+45 32 12 34 56',
      FI: '+358 41 2345678', AE: '+971 50 123 4567', IL: '+972 50 123 4567', JP: '+81 90 1234 5678',
      KR: '+82 10 1234 5678', HK: '+852 5123 4567', SG: '+65 8123 4567', MY: '+60 12 345 6789',
      PK: '+92 300 1234567', IN: '+91 98765 43210', SA: '+966 50 123 4567', QA: '+974 3312 3456'
    };
    var ZIP_OPTIONAL = ['AE','AG','AO','AW','BF','BI','BJ','BO','BS','BW','BZ','CD','CF','CG','CI','CK','CM','CW','DJ','DM','ER','FJ','GA','GD','GH','GM','GQ','GY','HK','IE','JM','KE','KI','KM','KN','KP','LC','ML','MO','MR','MW','NR','NU','PA','PK','QA','RW','SA','SB','SC','SL','SO','SR','SS','ST','SY','TD','TG','TK','TL','TO','TT','TV','TZ','UG','VU','YE','ZW'];

    function num(cents, dec, thousands, sep) {
      var parts = (cents / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(sep);
    }
    function money(cents, format) {
      if (!format) return '$' + num(cents, 2, ',', '.');
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
        switch (key) {
          case 'amount_no_decimals': return num(cents, 0, ',', '.');
          case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return num(cents, 2, "'", '.');
          case 'amount_no_decimals_with_space_separator': return num(cents, 0, ' ', '.');
          case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
          case 'amount_with_period_and_space_separator': return num(cents, 2, ' ', '.');
          default: return num(cents, 2, ',', '.');
        }
      });
    }
    function gql(query, variables) {
      return fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ query: query, variables: variables || {} }) })
        .then(function (r) { if (!r.ok) throw new Error('api'); return r.json(); })
        .then(function (j) { if (j.errors && j.errors.length) throw new Error(j.errors[0].message); return j.data; });
    }
    function cartId() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        .then(function (c) { return { id: 'gid://shopify/Cart/' + c.token, count: c.item_count }; });
    }

    function init(el) {
      if (!el || el.dataset.snReady) return;
      el.dataset.snReady = '1';
      var sid = el.getAttribute('data-section-id');
      var form = el.querySelector('[data-sn-ck-form]');
      if (!form) return;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var fmt = el.getAttribute('data-money');
      var fmtCur = el.getAttribute('data-money-currency');
      function q(s) { return el.querySelector(s); }
      var country = q('[data-sn-ck-country]');
      var province = q('[data-sn-ck-province]');
      var provinceWrap = q('[data-sn-ck-province-wrap]');
      var zip = q('[data-sn-ck-zip]');
      var phone = q('[data-sn-ck-phone]');
      var bCountry = q('[data-sn-ck-bcountry]');
      var bProvince = q('[data-sn-ck-bprovince]');
      var bProvinceWrap = q('[data-sn-ck-bprovince-wrap]');
      var billing = q('[data-sn-ck-billing]');
      var alertBox = q('[data-sn-ck-alert]');
      var lastShip = null;

      /* Province lists come from Shopify's own country data */
      var provinces = {};
      var tpl = q('[data-sn-ck-provinces]');
      if (tpl) {
        Array.prototype.forEach.call(tpl.content.querySelectorAll('option'), function (o) {
          try { provinces[o.value] = JSON.parse(o.getAttribute('data-provinces') || '[]'); } catch (e) { provinces[o.value] = []; }
        });
      }
      if (bCountry) Array.prototype.slice.call(bCountry.options).forEach(function (o) { if (!o.value || o.value === '---') o.remove(); });
      Array.prototype.forEach.call(bCountry ? bCountry.options : [], function (o) {
        if (!provinces[o.value]) { try { provinces[o.value] = JSON.parse(o.getAttribute('data-provinces') || '[]'); } catch (e) { provinces[o.value] = []; } }
      });

      function fillProvinces(select, wrap, name, keep) {
        var list = provinces[name] || [];
        keep = keep || select.value || select.getAttribute('data-initial') || '';
        select.innerHTML = '';
        if (!list.length) { wrap.hidden = true; select.required = false; setErr(select, ''); return; }
        wrap.hidden = false; select.required = true;
        select.appendChild(new Option('Select…', ''));
        list.forEach(function (p) {
          var o = new Option(p[1] || p[0], p[0]);
          if (keep && (p[0] === keep || p[1] === keep)) o.selected = true;
          select.appendChild(o);
        });
      }
      function countryName() { var o = country.options[country.selectedIndex]; return o ? (o.getAttribute('data-name') || o.textContent) : ''; }
      function syncCountry() {
        fillProvinces(province, provinceWrap, countryName());
        var optional = ZIP_OPTIONAL.indexOf(country.value) !== -1;
        zip.required = !optional;
        q('[data-sn-ck-zip-req]').hidden = optional;
        q('[data-sn-ck-zip-opt]').hidden = !optional;
        if (optional) setErr(zip, '');
        if (phone) phone.placeholder = PHONE_EXAMPLE[country.value] || 'Phone number with country code';
      }
      function syncBillingCountry() { if (bCountry) fillProvinces(bProvince, bProvinceWrap, bCountry.value); }

      /* ---------- Validation ---------- */
      function setErr(input, msg) {
        var id = input.id + '-err';
        var box = document.getElementById(id);
        if (!msg) {
          input.removeAttribute('aria-invalid');
          if (box) box.remove();
          return;
        }
        input.setAttribute('aria-invalid', 'true');
        if (!box) {
          box = document.createElement('p');
          box.id = id; box.className = 'sn-ckout__err';
          var anchor = input.closest('.sn-select') || input;
          anchor.insertAdjacentElement('afterend', box);
        }
        box.textContent = msg;
        input.setAttribute('aria-describedby', id);
      }
      function check(input) {
        if (input.closest('[hidden]')) { setErr(input, ''); return ''; }
        var v = (input.value || '').trim();
        var msg = '';
        if (input.required && !v) msg = input.getAttribute('data-msg') || 'This field is required.';
        else if (v && input.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) msg = 'Please enter a valid email address.';
        else if (v && input.type === 'tel' && v.replace(/\D/g, '').length < 7) msg = 'Please enter a valid phone number.';
        setErr(input, msg);
        return msg;
      }
      function validate() {
        var bad = [];
        form.querySelectorAll('[data-sn-ck-field], [data-sn-ck-bill]').forEach(function (input) { if (check(input)) bad.push(input); });
        return bad;
      }
      form.addEventListener('focusout', function (e) {
        var t = e.target;
        if (t.matches && t.matches('[data-sn-ck-field], [data-sn-ck-bill]') && t.getAttribute('aria-invalid') === 'true') check(t);
      });
      form.addEventListener('input', function (e) {
        var t = e.target;
        if (t.getAttribute && t.getAttribute('aria-invalid') === 'true') check(t);
      });

      function showAlert(msg) { alertBox.textContent = msg || ''; alertBox.hidden = !msg; }

      /* ---------- Shipping estimate (Shopify's live rates) ---------- */
      function paintTotals() {
        var shipEl = q('[data-sn-ck-ship]');
        var totalWrap = q('[data-total]');
        var totalEl = q('[data-sn-ck-total]');
        var noteEl = q('[data-sn-ck-total-note]');
        if (!shipEl || !totalWrap) return;
        var base = parseInt(totalWrap.getAttribute('data-total'), 10) || 0;
        var baseNote = noteEl ? noteEl.getAttribute('data-base') : '';
        shipEl.classList.remove('is-free');
        shipEl.classList.add('is-muted');
        if (lastShip && lastShip.state === 'ok') {
          shipEl.classList.remove('is-muted');
          if (lastShip.cents === 0) { shipEl.textContent = 'Complimentary'; shipEl.classList.add('is-free'); }
          else shipEl.textContent = money(lastShip.cents, fmt);
          totalEl.textContent = money(base + lastShip.cents, fmtCur);
          if (noteEl) noteEl.textContent = lastShip.cents === 0 ? baseNote : 'Incl. shipping';
        } else {
          shipEl.textContent = lastShip && lastShip.state === 'later' ? 'Calculated at payment' : 'Enter your address';
          totalEl.textContent = money(base, fmtCur);
          if (noteEl) noteEl.textContent = baseNote;
        }
      }
      var shipTimer, shipSeq = 0;
      function estimate() {
        clearTimeout(shipTimer);
        shipTimer = setTimeout(function () {
          var z = zip.value.trim();
          if ((zip.required && !z) || (!provinceWrap.hidden && !province.value)) { lastShip = null; paintTotals(); return; }
          var params = new URLSearchParams();
          params.set('shipping_address[country]', countryName());
          if (!provinceWrap.hidden && province.value) params.set('shipping_address[province]', province.value);
          if (z) params.set('shipping_address[zip]', z);
          var seq = ++shipSeq;
          fetch(root + 'cart/shipping_rates.json?' + params.toString(), { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
            .then(function (res) {
              if (seq !== shipSeq) return;
              var rates = res.ok ? (res.json.shipping_rates || []).map(function (r) { return Math.round(parseFloat(r.price) * 100); }).filter(function (n) { return !isNaN(n); }) : [];
              lastShip = rates.length ? { state: 'ok', cents: Math.min.apply(null, rates) } : { state: 'later' };
              paintTotals();
            })
            .catch(function () { if (seq === shipSeq) { lastShip = { state: 'later' }; paintTotals(); } });
        }, 450);
      }

      country.addEventListener('change', function () { syncCountry(); estimate(); });
      province.addEventListener('change', estimate);
      zip.addEventListener('input', estimate);
      if (bCountry) bCountry.addEventListener('change', syncBillingCountry);

      /* ---------- Billing address choice ---------- */
      form.querySelectorAll('[data-sn-ck-billing-mode]').forEach(function (r) {
        r.addEventListener('change', function () {
          var different = form.querySelector('[data-sn-ck-billing-mode]:checked').value === 'different';
          billing.hidden = !different;
          if (different) {
            if (bCountry && !bCountry.dataset.touched) { bCountry.value = countryName(); syncBillingCountry(); }
            var first = billing.querySelector('input');
            if (first) first.focus();
          }
        });
      });
      if (bCountry) bCountry.addEventListener('change', function () { bCountry.dataset.touched = '1'; });

      /* ---------- Discount codes (Shopify cart) ---------- */
      function renderSummary(html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sn-ck-summary-inner]');
        var cur = q('[data-sn-ck-summary-inner]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        paintTotals();
      }
      function codes() { return Array.prototype.map.call(el.querySelectorAll('[data-sn-ck-discount-remove]'), function (b) { return b.getAttribute('data-sn-ck-discount-remove'); }); }
      function updateDiscounts(list, applied) {
        var summary = q('[data-sn-ck-summary]');
        summary.classList.add('is-busy');
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: list.join(','), sections: [sid], sections_url: location.pathname })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (cart.sections) renderSummary(cart.sections[sid]);
            if (lastShip && lastShip.state === 'ok') estimate();
            if (applied) {
              var found = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === applied.toLowerCase(); })[0];
              var msg = q('[data-sn-ck-discount-msg]');
              if (msg) {
                msg.hidden = false;
                msg.classList.toggle('is-ok', !!(found && found.applicable));
                msg.textContent = found && found.applicable ? 'Code applied.' : 'This code is not valid for your order.';
              }
            }
          })
          .catch(function () {
            var msg = q('[data-sn-ck-discount-msg]');
            if (msg) { msg.hidden = false; msg.classList.remove('is-ok'); msg.textContent = 'Connection problem. Please try again.'; }
          })
          .finally(function () { summary.classList.remove('is-busy'); });
      }
      el.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('[data-sn-ck-discount-apply]')) {
          var field = q('[data-sn-ck-discount]');
          var code = field && field.value.trim();
          if (!code) { if (field) field.focus(); return; }
          updateDiscounts(codes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); }).concat([code]), code);
          return;
        }
        var rm = t.closest('[data-sn-ck-discount-remove]');
        if (rm) {
          var drop = rm.getAttribute('data-sn-ck-discount-remove');
          updateDiscounts(codes().filter(function (c) { return c !== drop; }));
        }
      });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-sn-ck-discount]')) {
          e.preventDefault();
          var b = q('[data-sn-ck-discount-apply]'); if (b) b.click();
        }
      });

      /* ---------- Proceed to Payment: save details to the cart, then open Shopify's secure payment step ---------- */
      function val(key) { var i = form.querySelector('[data-sn-ck-field="' + key + '"]'); return i ? i.value.trim() : ''; }
      function bval(key) { var i = form.querySelector('[data-sn-ck-bill="' + key + '"]'); return i ? i.value.trim() : ''; }
      var busy = false;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        showAlert('');
        var bad = validate();
        if (bad.length) {
          showAlert(bad.length === 1 ? 'Please check the highlighted field.' : 'Please check the ' + bad.length + ' highlighted fields.');
          bad[0].focus();
          return;
        }
        var btn = el.querySelector('[data-sn-ck-submit]');
        var label = el.querySelector('[data-sn-ck-submit-label]');
        var original = label ? label.textContent : '';
        busy = true;
        if (btn) btn.classList.add('is-loading');
        if (label) label.textContent = 'Securing your details…';

        var delivery = {
          firstName: val('firstName'), lastName: val('lastName'), company: val('company') || null,
          address1: val('address1'), address2: val('address2') || null, city: val('city'),
          countryCode: val('countryCode'), zip: val('zip') || null, phone: val('phone')
        };
        if (!provinceWrap.hidden && province.value) delivery.provinceCode = province.value;
        var different = form.querySelector('[data-sn-ck-billing-mode]:checked').value === 'different';
        var bill;
        if (different) {
          bill = { firstName: bval('firstName'), lastName: bval('lastName'), address1: bval('address1'), address2: bval('address2') || null, city: bval('city'), country: bval('country'), zip: bval('zip') || null };
          if (!bProvinceWrap.hidden && bProvince.value) bill.province = bProvince.value;
        } else {
          /* Same as shipping: send it as the billing address too, so the payment step always matches */
          bill = { firstName: delivery.firstName, lastName: delivery.lastName, company: delivery.company, address1: delivery.address1, address2: delivery.address2, city: delivery.city, country: countryName(), zip: delivery.zip, phone: delivery.phone };
          if (!provinceWrap.hidden && province.value) bill.province = province.value;
        }
        var mutation = 'mutation SnoutCheckout($id: ID!, $addresses: [CartSelectableAddressInput!]!, $buyer: CartBuyerIdentityInput!, $billing: MailingAddressInput) { ' +
          'delivery: cartDeliveryAddressesReplace(cartId: $id, addresses: $addresses) { userErrors { field message } } ' +
          'buyer: cartBuyerIdentityUpdate(cartId: $id, buyerIdentity: $buyer) { userErrors { field message } } ' +
          'billing: cartBillingAddressUpdate(cartId: $id, billingAddress: $billing) { cart { checkoutUrl } userErrors { field message } } }';

        function fail(msg) {
          busy = false;
          if (btn) btn.classList.remove('is-loading');
          if (label) label.textContent = original;
          showAlert(msg);
          alertBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        cartId()
          .then(function (c) {
            if (!c.count) { window.location.reload(); return null; }
            return gql(mutation, {
              id: c.id,
              addresses: [{ selected: true, oneTimeUse: false, address: { deliveryAddress: delivery } }],
              buyer: { email: val('email') },
              billing: bill
            });
          })
          .then(function (data) {
            if (!data) return;
            var errors = [].concat(data.delivery.userErrors || [], data.buyer.userErrors || [], data.billing.userErrors || []);
            if (errors.length) {
              var m = errors[0].message || '';
              if (/email/i.test(m) || /email/i.test((errors[0].field || []).join(' '))) { setErr(form.querySelector('[data-sn-ck-field="email"]'), m); }
              fail(m ? 'Please check your details: ' + m : 'Please check your details and try again.');
              return;
            }
            var url = data.billing.cart && data.billing.cart.checkoutUrl;
            window.location.href = url || (root + 'checkout');
          })
          .catch(function () {
            fail('We could not save your details just now. Please try again — or continue to the secure checkout and enter them there.');
            var link = document.createElement('a');
            link.href = root + 'checkout';
            link.textContent = ' Continue to secure checkout →';
            link.style.textDecoration = 'underline';
            alertBox.appendChild(link);
          });
      });

      /* ---------- Prefill from the cart (e.g. after "Return to cart" from payment) ---------- */
      function prefill() {
        cartId().then(function (c) {
          if (!c.count) return null;
          return gql('query SnoutCheckoutPrefill($id: ID!) { cart(id: $id) { buyerIdentity { email } delivery { addresses { selected address { ... on CartDeliveryAddress { firstName lastName company address1 address2 city provinceCode countryCode zip phone } } } } } }', { id: c.id });
        }).then(function (data) {
          if (!data || !data.cart) return;
          function put(key, v) { var i = form.querySelector('[data-sn-ck-field="' + key + '"]'); if (i && v && !i.value) i.value = v; }
          put('email', data.cart.buyerIdentity && data.cart.buyerIdentity.email);
          var list = (data.cart.delivery && data.cart.delivery.addresses) || [];
          var sel = list.filter(function (a) { return a.selected; })[0] || list[0];
          var a = sel && sel.address;
          if (!a) return;
          var untouched = !val('firstName') && !val('address1');
          if (untouched && a.countryCode && country.querySelector('option[value="' + a.countryCode + '"]') && country.value !== a.countryCode) { country.value = a.countryCode; syncCountry(); }
          ['firstName', 'lastName', 'company', 'address1', 'address2', 'city', 'zip', 'phone'].forEach(function (k) { put(k, a[k]); });
          estimate();
        }).catch(function () {});
      }

      syncCountry();
      syncBillingCountry();
      paintTotals();
      prefill();
      estimate();
    }

    function boot() { document.querySelectorAll('[data-sn-checkout]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-sn-checkout]')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snout-commission"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(form) {
      if (!form || form.dataset.snReady) return;
      form.dataset.snReady = '1';
      var btn = form.querySelector('[data-sn-co-submit]');
      var label = form.querySelector('[data-sn-co-label]');
      var errBox = form.querySelector('[data-sn-co-error]');
      var original = label ? label.textContent : '';
      var busy = false;
      function fieldErr(input, msg) {
        var id = input.id + '-err';
        var box = document.getElementById(id);
        if (!msg) { input.removeAttribute('aria-invalid'); if (box) box.remove(); return; }
        input.setAttribute('aria-invalid', 'true');
        if (!box) {
          box = document.createElement('p'); box.id = id; box.className = 'sn-field__error';
          (input.closest('.sn-select') || input).insertAdjacentElement('afterend', box);
        }
        box.textContent = msg;
        input.setAttribute('aria-describedby', id);
      }
      function check(input) {
        var v = (input.value || '').trim();
        var msg = '';
        if (input.required && !v) msg = input.getAttribute('data-msg') || 'This field is required.';
        else if (v && input.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) msg = 'Please enter a valid email address.';
        fieldErr(input, msg);
        return msg;
      }
      form.addEventListener('input', function (e) { if (e.target.getAttribute && e.target.getAttribute('aria-invalid') === 'true') check(e.target); });
      form.addEventListener('change', function (e) { if (e.target.getAttribute && e.target.getAttribute('aria-invalid') === 'true') check(e.target); });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        errBox.hidden = true;
        var bad = [];
        form.querySelectorAll('input[required], select[required], textarea[required]').forEach(function (i) { if (check(i)) bad.push(i); });
        if (bad.length) { bad[0].focus(); return; }
        busy = true;
        btn.classList.add('is-loading');
        if (label) label.textContent = 'Adding your custom mask…';
        var data = new FormData(form);
        data.delete('return_to');
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var variantId = String(data.get('id'));
        var idea = String(data.get('properties[Your Idea]') || '').trim();
        /* If this exact request is already in the bag (double click, back button, retry after a network drop),
           don't add it a second time: go straight to checkout instead. */
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { items: [] }; })
          .catch(function () { return { items: [] }; })
          .then(function (cart) {
            var dup = (cart.items || []).some(function (it) {
              return String(it.variant_id) === variantId && it.properties && String(it.properties['Your Idea'] || '').trim() === idea;
            });
            if (dup) return { ok: true, json: {} };
            return fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data })
              .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); });
          })
          .then(function (res) {
            if (!res.ok) throw new Error(res.json.description || res.json.message || 'error');
            if (label) label.textContent = 'Opening secure checkout…';
            window.location.href = form.getAttribute('data-checkout');
          })
          .catch(function (err) {
            busy = false;
            btn.classList.remove('is-loading');
            if (label) label.textContent = original;
            errBox.textContent = 'We could not start your order just now. Please try again, or contact us if it keeps happening.';
            errBox.hidden = false;
          });
      });
    }
    function boot() { document.querySelectorAll('[data-sn-custom-order]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-sn-custom-order]')); });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      document.querySelectorAll('[data-sn-custom-order]').forEach(function (f) {
        var b = f.querySelector('[data-sn-co-submit]'); if (b) b.classList.remove('is-loading');
        f.dataset.snReady = ''; init(f);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snout-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-sn-faq]').forEach(function (wrap) {
        if (wrap.dataset.snReady) return;
        wrap.dataset.snReady = '1';
        var cats = Array.prototype.slice.call(wrap.querySelectorAll('[data-sn-faq-cat]'));
        var items = Array.prototype.slice.call(wrap.querySelectorAll('[data-sn-faq-item]'));
        var empty = wrap.querySelector('[data-sn-faq-empty]');

        function select(btn) {
          var key = btn.getAttribute('data-sn-faq-cat');
          cats.forEach(function (c) {
            var on = c === btn;
            c.classList.toggle('is-active', on);
            c.setAttribute('aria-pressed', String(on));
          });
          var visible = [];
          items.forEach(function (it) {
            var show = key === 'all' || it.getAttribute('data-cat') === key;
            it.hidden = !show;
            if (show) visible.push(it); else it.open = false;
          });
          if (visible.length && !visible.some(function (it) { return it.open; })) visible[0].open = true;
          if (empty) empty.hidden = visible.length > 0;
          // Keep the chosen pill in view on phones
          var row = btn.parentElement;
          if (row && row.scrollWidth > row.clientWidth) {
            var r = row.getBoundingClientRect(), b = btn.getBoundingClientRect();
            if (b.left < r.left || b.right > r.right) row.scrollLeft += b.left - r.left - 8;
          }
        }

        cats.forEach(function (c) {
          c.addEventListener('click', function () {
            select(c);
            var key = c.getAttribute('data-sn-faq-cat');
            if (history.replaceState) history.replaceState(null, '', key === 'all' ? location.pathname + location.search : '#' + key);
          });
        });

        // Only one answer open at a time (for browsers without <details name>)
        items.forEach(function (it) {
          it.addEventListener('toggle', function () {
            if (!it.open) return;
            items.forEach(function (other) { if (other !== it && other.open) other.open = false; });
          });
        });

        // Links such as /pages/faq#artisan-sizing-fit open that topic
        var hash = '';
        try { hash = decodeURIComponent(location.hash.slice(1)); } catch (e) {}
        if (hash) {
          var match = cats.filter(function (c) { return c.getAttribute('data-sn-faq-cat') === hash; })[0];
          if (match) { select(match); wrap.scrollIntoView({ block: 'start' }); }
        }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snout-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORE = 'snoutNewsletterPopup';
    function state() { try { return JSON.parse(localStorage.getItem(STORE) || '{}') || {}; } catch (e) { return {}; } }
    function save(s) { try { localStorage.setItem(STORE, JSON.stringify(s)); } catch (e) {} }

    function init(scope) {
      scope.querySelectorAll('[data-sn-popup]').forEach(function (root) {
        if (root.dataset.snReady) return;
        root.dataset.snReady = '1';
        var dialog = root.querySelector('[data-sn-popup-dialog]');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        var designMode = root.hasAttribute('data-design-mode');

        function open() {
          if (dialog.open) return;
          dialog.showModal();
          document.documentElement.classList.add('sn-pop-lock');
        }
        function close() {
          if (!dialog.open) return;
          dialog.close();
        }
        dialog.addEventListener('close', function () {
          document.documentElement.classList.remove('sn-pop-lock');
          if (designMode) return;
          var s = state();
          if (!s.subscribed) { s.dismissedAt = Date.now(); save(s); }
        });
        dialog.addEventListener('click', function (e) {
          if (e.target === dialog || e.target.closest('[data-sn-popup-close]')) close();
        });

        /* Form: split the name, check the fields before posting */
        var form = dialog.querySelector('form');
        if (form) {
          form.addEventListener('submit', function (e) {
            var name = form.querySelector('[data-sn-popup-name]');
            var email = form.querySelector('input[type="email"]');
            var consent = form.querySelector('[data-sn-popup-consent]');
            var hint = form.querySelector('[data-sn-popup-hint]');
            var problem = null;
            if (name && !name.value.trim()) problem = [name, 'Please enter your name.'];
            else if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) problem = [email, 'Please enter a valid email address.'];
            else if (consent && !consent.checked) problem = [consent, 'Please tick the box to agree before subscribing.'];
            [name, email].forEach(function (f) { if (f) f.removeAttribute('aria-invalid'); });
            if (problem) {
              e.preventDefault();
              if (problem[0] !== consent) problem[0].setAttribute('aria-invalid', 'true');
              if (hint) { hint.textContent = problem[1]; hint.hidden = false; }
              problem[0].focus();
              return;
            }
            if (hint) hint.hidden = true;
            var parts = name.value.trim().split(/\s+/);
            name.value = parts.shift();
            var last = form.querySelector('[data-sn-popup-last]');
            if (last) last.value = parts.join(' ');
          });
        }

        /* After a post the page reloads with the result inside the popup */
        var result = dialog.querySelector('[data-sn-popup-state]');
        if (result && !designMode) {
          if (result.getAttribute('data-sn-popup-state') === 'success') { var s = state(); s.subscribed = true; save(s); }
          open();
          var focusTarget = dialog.querySelector('.sn-pop__done .sn-pop__title') || dialog.querySelector('input[aria-invalid="true"]');
          if (focusTarget) focusTarget.focus();
          return;
        }

        if (designMode) {
          document.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === root.dataset.sectionId) open(); });
          document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === root.dataset.sectionId) close(); });
          return;
        }

        /* A link ending in ?newsletter=open or #newsletter always opens it */
        if (/[?&]newsletter=open(&|$)/.test(window.location.search) || window.location.hash === '#newsletter') { open(); return; }

        /* Automatic opening: once, after a delay, not on the cart or checkout pages */
        if (root.dataset.template === 'cart' || root.dataset.template === 'checkout') return;
        if (root.dataset.mobile === 'false' && window.matchMedia('(max-width: 767px)').matches) return;
        var st = state();
        if (st.subscribed) return;
        var days = parseInt(root.dataset.days, 10) || 14;
        if (st.dismissedAt && Date.now() - st.dismissedAt < days * 86400000) return;
        var delay = Math.max(0, parseInt(root.dataset.delay, 10) || 0) * 1000;
        setTimeout(function () {
          if (document.querySelector('dialog[open]:not([data-sn-popup-dialog])')) return;
          open();
        }, delay);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snout-product-tabs"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    var go = e.target.closest && e.target.closest('[data-sn-go-tab]');
    if (!go) return;
    var tab = document.getElementById(go.getAttribute('data-sn-go-tab'));
    if (tab) { tab.click(); tab.focus(); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snout-product"]) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-sn-pdp]').forEach(function (pdp) {
        if (pdp.dataset.snReady) return;
        pdp.dataset.snReady = '1';
        var data = {};
        try { data = JSON.parse(pdp.querySelector('[data-sn-product-json]').textContent); } catch (e) {}
        var form = pdp.querySelector('[data-sn-pdp-form]');
        var slides = Array.prototype.slice.call(pdp.querySelectorAll('[data-sn-media]'));
        var thumbs = Array.prototype.slice.call(pdp.querySelectorAll('[data-sn-thumb]'));
        var errorBox = pdp.querySelector('[data-sn-pdp-error]');

        /* ---------- Gallery ---------- */
        function currentIndex() { for (var i = 0; i < slides.length; i++) if (!slides[i].hidden) return i; return 0; }
        function show(id) {
          id = String(id);
          if (!slides.some(function (s) { return s.getAttribute('data-sn-media') === id; })) return;
          slides.forEach(function (s) { s.hidden = s.getAttribute('data-sn-media') !== id; });
          thumbs.forEach(function (t) { t.setAttribute('aria-current', String(t.getAttribute('data-sn-thumb') === id)); });
        }
        thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-sn-thumb')); }); });

        var dialog = pdp.querySelector('[data-sn-lightbox]');
        var dialogImg = dialog && dialog.querySelector('[data-sn-lightbox-img]');
        function paintLightbox() { var s = slides[currentIndex()]; if (s && dialogImg) dialogImg.src = s.getAttribute('data-full'); }
        function stepLightbox(d) { if (!slides.length) return; var i = (currentIndex() + d + slides.length) % slides.length; show(slides[i].getAttribute('data-sn-media')); paintLightbox(); }
        var zoom = pdp.querySelector('[data-sn-zoom]');
        if (zoom && dialog && typeof dialog.showModal === 'function') {
          zoom.addEventListener('click', function () { paintLightbox(); dialog.showModal(); });
          dialog.addEventListener('click', function (e) {
            if (e.target === dialog) dialog.close();
            var step = e.target.closest('[data-sn-lightbox-step]');
            if (step) stepLightbox(parseInt(step.getAttribute('data-sn-lightbox-step'), 10));
            if (e.target.closest('[data-sn-lightbox-close]')) dialog.close();
          });
          dialog.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowRight') stepLightbox(1);
            if (e.key === 'ArrowLeft') stepLightbox(-1);
          });
        }

        /* ---------- Quantity ---------- */
        var qty = pdp.querySelector('[data-sn-qty-input]');
        pdp.querySelectorAll('[data-sn-qty-step]').forEach(function (b) {
          b.addEventListener('click', function () {
            var v = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-sn-qty-step'), 10));
            qty.value = v;
          });
        });
        if (qty) qty.addEventListener('change', function () { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); });

        /* ---------- Choices (saved on the order) ---------- */
        pdp.querySelectorAll('[data-sn-choice]').forEach(function (group) {
          var out = group.querySelector('[data-sn-choice-value]');
          function paint() { var c = group.querySelector('[data-sn-choice-input]:checked'); if (out) out.textContent = c ? c.value : ''; }
          group.addEventListener('change', paint);
          paint();
        });

        /* ---------- Variants ---------- */
        var picker = pdp.querySelector('[data-sn-variant-picker]');
        var idInput = pdp.querySelector('[data-sn-variant-id]');
        function setText(sel, txt, hideWhenEmpty) {
          pdp.querySelectorAll(sel).forEach(function (el) { el.textContent = txt || ''; if (hideWhenEmpty) el.hidden = !txt; });
        }
        function applyVariant(v) {
          if (!v) return;
          idInput.value = v.id;
          setText('[data-sn-price]', v.price);
          setText('[data-sn-buy-price]', v.price);
          setText('[data-sn-compare]', v.compare, true);
          setText('[data-sn-save]', v.save, true);
          setText('[data-sn-sku]', v.sku);
          var skuRow = pdp.querySelector('[data-sn-sku-row]'); if (skuRow) skuRow.hidden = !v.sku;
          var skuRun = pdp.querySelector('[data-sn-sku-run]'); if (skuRun) skuRun.hidden = !v.sku;
          setText('[data-sn-sku-text]', v.sku);
          var add = pdp.querySelector('[data-sn-pdp-add]'); var buy = pdp.querySelector('[data-sn-pdp-buy]');
          if (add) add.disabled = !v.available; if (buy) buy.disabled = !v.available;
          setText('[data-sn-add-label]', v.available ? data.addLabel : 'Sold Out');
          var stock = pdp.querySelector('[data-sn-stock]');
          if (stock) { stock.classList.toggle('is-out', !v.available); setText('[data-sn-stock-text]', v.available ? data.inStock : 'Sold Out'); }
          if (v.media) show(v.media);
          if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
        }
        if (picker && data.variants) {
          picker.addEventListener('change', function () {
            var chosen = [];
            picker.querySelectorAll('[data-sn-opt-group]').forEach(function (fs, i) {
              var c = fs.querySelector('input:checked'); chosen[i] = c ? c.value : null;
              var out = pdp.querySelector('[data-sn-opt-value="' + (i + 1) + '"]'); if (out && c) out.textContent = c.value;
            });
            var match = data.variants.filter(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); })[0];
            if (match) applyVariant(match);
          });
        }

        /* ---------- Add to cart ---------- */
        if (!form) return;
        form.addEventListener('submit', function (e) {
          var submitter = e.submitter;
          if (submitter && submitter.hasAttribute('data-sn-pdp-buy')) return; // Buy Now: native post straight to checkout
          var actions = window.Shopify && window.Shopify.actions;
          if (!actions || typeof actions.updateCart !== 'function') return; // native fallback: goes to the cart page
          e.preventDefault();
          var btn = submitter || form.querySelector('[data-sn-pdp-add]');
          var attrs = [];
          new FormData(form).forEach(function (value, key) {
            var m = /^properties\[(.+)\]$/.exec(key);
            if (m && value !== '') attrs.push({ key: m[1], value: String(value) });
          });
          var quantity = Math.max(1, parseInt(qty && qty.value, 10) || 1);
          if (errorBox) errorBox.hidden = true;
          btn.classList.add('is-loading');
          actions.updateCart({ lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + idInput.value, quantity: quantity, attributes: attrs }] })
            .then(function (res) {
              if (res && res.userErrors && res.userErrors.length) {
                if (errorBox) { errorBox.textContent = res.userErrors[0].message; errorBox.hidden = false; }
                return;
              }
              var n = res && res.cart && res.cart.totalQuantity;
              if (typeof n === 'number') document.querySelectorAll('[data-sn-cart-count]').forEach(function (el) { el.textContent = n > 99 ? '99+' : String(n); el.hidden = n === 0; });
              btn.classList.add('is-added');
              setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
              if (typeof actions.openCart === 'function') return actions.openCart();
            })
            .catch(function () { HTMLFormElement.prototype.submit.call(form); })
            .finally(function () { btn.classList.remove('is-loading'); });
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snout-size-chart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'snoutUnit';
    function apply(unit) {
      document.documentElement.setAttribute('data-sn-unit', unit);
      document.querySelectorAll('[data-sn-unit]').forEach(function (btn) {
        if (btn.tagName === 'BUTTON') btn.setAttribute('aria-pressed', String(btn.getAttribute('data-sn-unit') === unit));
      });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-sn-units] [data-sn-unit]');
      if (!btn) return;
      var unit = btn.getAttribute('data-sn-unit');
      apply(unit);
      try { localStorage.setItem(KEY, unit); } catch (err) {}
    });
    function restore() {
      var saved = null;
      try { saved = localStorage.getItem(KEY); } catch (err) {}
      if (saved === 'cm' || saved === 'in') apply(saved);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore); else restore();
    document.addEventListener('shopify:section:load', restore);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snout-track-order"]) return;
  try {
    
  (function () {
    function norm(v) { return String(v || '').trim().replace(/^#/, '').replace(/\s+/g, '').toLowerCase(); }
    function isEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

    function init(el) {
      if (!el || el.dataset.snReady) return;
      el.dataset.snReady = '1';
      var form = el.querySelector('[data-sn-track-form]');
      if (!form) return;
      var orderInput = el.querySelector('[data-sn-track-order]');
      var emailInput = el.querySelector('[data-sn-track-email]');
      var alertBox = el.querySelector('[data-sn-track-alert]');
      var status = el.querySelector('[data-sn-track-status]');
      var result = el.querySelector('[data-sn-track-result]');
      var btn = el.querySelector('[data-sn-track-submit]');
      var signedIn = el.getAttribute('data-signed-in') === 'true';
      var accountsOn = el.getAttribute('data-accounts') === 'true';
      var customerEmail = (el.getAttribute('data-email') || '').toLowerCase();

      function setErr(input, msg) {
        var id = input.id + '-err';
        var box = document.getElementById(id);
        if (!msg) { input.removeAttribute('aria-invalid'); if (box) box.remove(); return; }
        input.setAttribute('aria-invalid', 'true');
        if (!box) { box = document.createElement('p'); box.id = id; box.className = 'sn-track__err'; input.insertAdjacentElement('afterend', box); }
        box.textContent = msg;
        input.setAttribute('aria-describedby', id);
      }
      function showAlert(msg) { alertBox.textContent = msg || ''; alertBox.hidden = !msg; }
      function showStatus(html, ok) {
        if (!html) { status.hidden = true; status.innerHTML = ''; return; }
        status.innerHTML = html;
        status.className = 'sn-form-msg sn-track__status ' + (ok ? 'sn-form-msg--ok' : 'sn-form-msg--error');
        status.hidden = false;
      }
      function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
      function hideOrders() {
        el.querySelectorAll('[data-sn-order]').forEach(function (o) { o.hidden = true; o.classList.remove('is-active'); });
        el.querySelectorAll('[data-sn-track-pick]').forEach(function (c) { c.classList.remove('is-active'); });
      }
      function showOrder(num, scroll) {
        hideOrders();
        var match = null;
        el.querySelectorAll('[data-sn-order]').forEach(function (o) {
          if (!match && (o.getAttribute('data-sn-order') === num || o.getAttribute('data-number') === num)) match = o;
        });
        if (!match) return false;
        match.hidden = false;
        match.classList.add('is-active');
        el.querySelectorAll('[data-sn-track-pick="' + num + '"]').forEach(function (c) { c.classList.add('is-active'); });
        showStatus('');
        if (scroll) match.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return true;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        showAlert('');
        var num = norm(orderInput.value);
        var email = emailInput.value.trim();
        var bad = [];
        setErr(orderInput, num ? '' : 'Please enter your order ID.'); if (!num) bad.push(orderInput);
        var emailMsg = !email ? 'Please enter the email used at checkout.' : (!isEmail(email) ? 'Please enter a valid email address.' : '');
        setErr(emailInput, emailMsg); if (emailMsg) bad.push(emailInput);
        if (bad.length) { bad[0].focus(); return; }

        if (!signedIn) {
          if (!accountsOn) {
            showAlert('Online order lookup is not available right now. Please use the link in your shipping confirmation email, or contact us and we will help.');
            return;
          }
          /* Shopify confirms the email with a one-time code, then brings the customer back here with the order open */
          var login = new URL(el.getAttribute('data-login') || '/customer_authentication/login', window.location.origin);
          login.searchParams.set('return_to', (el.getAttribute('data-page') || window.location.pathname) + '?order=' + encodeURIComponent(num));
          login.searchParams.set('login_hint', email);
          btn.classList.add('is-loading');
          el.querySelector('[data-sn-track-label]').textContent = 'Opening secure sign-in…';
          window.location.href = login.pathname + login.search;
          return;
        }

        if (email.toLowerCase() !== customerEmail) {
          hideOrders();
          var out = el.querySelector('.sn-track__session a');
          showStatus('You are signed in as ' + esc(customerEmail) + '. To track an order placed with ' + esc(email) + ', ' + (out ? '<a href="' + out.getAttribute('href') + '">sign out</a>' : 'sign out') + ' and try again with that email.', false);
          return;
        }
        if (!showOrder(num, true)) {
          showStatus('We could not find order #' + esc(num.toUpperCase()) + ' on this account. Please check the order ID in your confirmation email.', false);
          status.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
      [orderInput, emailInput].forEach(function (i) { i.addEventListener('input', function () { if (i.getAttribute('aria-invalid')) setErr(i, ''); }); });

      el.addEventListener('click', function (e) {
        var pick = e.target.closest('[data-sn-track-pick]');
        if (pick) {
          var n = pick.getAttribute('data-sn-track-pick');
          orderInput.value = '#' + n.toUpperCase();
          setErr(orderInput, '');
          showOrder(n, true);
          return;
        }
        if (e.target.closest('[data-sn-track-print]')) window.print();
      });

      /* Back from secure sign-in (or a shared link): open the requested order */
      var wanted = norm(new URLSearchParams(window.location.search).get('order'));
      if (wanted) {
        orderInput.value = '#' + wanted.toUpperCase();
        if (signedIn) {
          if (!showOrder(wanted, true)) {
            showStatus('We could not find order #' + esc(wanted.toUpperCase()) + ' on this account. Please check the order ID in your confirmation email.', false);
          }
        }
      }
    }

    function boot() { document.querySelectorAll('[data-sn-track]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-sn-track]')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snout-wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function num(cents, dec, thousands, sep) {
      var parts = (cents / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(sep);
    }
    function money(cents, format) {
      if (!format) return '$' + num(cents, 2, ',', '.');
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
        switch (key) {
          case 'amount_no_decimals': return num(cents, 0, ',', '.');
          case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return num(cents, 2, "'", '.');
          case 'amount_no_decimals_with_space_separator': return num(cents, 0, ' ', '.');
          case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
          case 'amount_with_period_and_space_separator': return num(cents, 2, ' ', '.');
          default: return num(cents, 2, ',', '.');
        }
      });
    }
    function splitTitle(title) {
      var short = (title.split(/ – | — | —| \| | - |, /)[0] || '').trim() || title;
      var rest = title.slice(short.length).trim().replace(/^[–—|,\-]\s*/, '');
      return [short, rest];
    }
    function setCartCount(n) {
      document.querySelectorAll('[data-sn-cart-count]').forEach(function (c) { c.textContent = n > 99 ? '99+' : String(n); c.hidden = n === 0; });
    }

    function init(scope) {
      scope.querySelectorAll('[data-sn-wishlist]').forEach(function (el) {
        if (el.dataset.snReady) return;
        el.dataset.snReady = '1';
        var W = window.SnoutWishlist;
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        function q(s) { return el.querySelector(s); }
        var list = q('[data-sn-wish-list]');
        var tpl = q('[data-sn-wish-tpl]');
        var emptyBox = q('[data-sn-wish-empty]');
        var bar = q('[data-sn-wish-bar]');
        var headRow = q('[data-sn-wish-headrow]');
        var loading = q('[data-sn-wish-loading]');
        var msg = q('[data-sn-wish-msg]');
        var shareInput = q('[data-sn-wish-share]');
        var total = q('[data-sn-wish-total]');
        var clearBtn = q('[data-sn-wish-clear]');
        var sharedBox = q('[data-sn-wish-shared]');
        var format = el.getAttribute('data-money');
        var addLabel = el.getAttribute('data-add-label') || 'Add To Cart';
        var optionsLabel = el.getAttribute('data-options-label') || 'Choose Options';

        var params = new URLSearchParams(window.location.search);
        var shared = params.get('items');
        shared = shared ? shared.split(',').map(function (h) { return h.trim(); }).filter(function (h) { return /^[a-z0-9][a-z0-9\-]*$/i.test(h); }).slice(0, 60) : null;
        if (shared && !shared.length) shared = null;

        var cache = {};
        var rows = [];

        function say(text, ok) { msg.textContent = text || ''; msg.hidden = !text; msg.classList.toggle('is-ok', !!ok); }
        function entries() {
          if (shared) return shared.map(function (h) { return { h: h, t: null }; });
          return W ? W.items() : [];
        }
        function fetchProduct(handle) {
          if (cache[handle] !== undefined) return Promise.resolve(cache[handle]);
          return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) {
              if (r.status === 404) return { gone: true };
              return r.ok ? r.json() : null;
            })
            .catch(function () { return null; })
            .then(function (p) { if (p) cache[handle] = p; return p; });
        }

        function load() {
          var items = entries();
          if (sharedBox) sharedBox.hidden = !shared;
          el.classList.toggle('is-shared', !!shared);
          if (!items.length) { rows = []; render(); return; }
          return Promise.all(items.map(function (it) { return fetchProduct(it.h); })).then(function (res) {
            var gone = [];
            rows = [];
            items.forEach(function (it, i) {
              var p = res[i];
              if (p && p.gone) gone.push(it.h);
              else if (p) rows.push({ h: it.h, t: it.t, p: p });
            });
            render();
            if (!shared && W && gone.length) gone.forEach(function (h) { W.remove(h); });
          });
        }

        function render() {
          loading.hidden = true;
          list.textContent = '';
          var has = rows.length > 0;
          emptyBox.hidden = has;
          bar.hidden = !has;
          headRow.hidden = !has;
          rows.forEach(function (row) {
            var p = row.p;
            var node = tpl.content.firstElementChild.cloneNode(true);
            var names = splitTitle(p.title || '');
            var url = p.url || (root + 'products/' + row.h);
            node.setAttribute('data-handle', row.h);
            node.querySelectorAll('[data-sn-wish-link]').forEach(function (a) { a.href = url; });
            node.querySelector('[data-sn-wish-title]').textContent = names[0];
            var sub = node.querySelector('[data-sn-wish-sub]');
            sub.textContent = names[1] || p.type || '';
            sub.hidden = !sub.textContent;
            var img = node.querySelector('[data-sn-wish-img]');
            var src = p.featured_image || (p.images && p.images[0]);
            if (src) { img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=240'; } else { img.remove(); }
            var variants = p.variants || [];
            var v = variants.filter(function (x) { return x.available; })[0] || variants[0];
            var price = v ? v.price : p.price;
            node.querySelector('[data-sn-wish-price]').textContent = money(price, format);
            var compare = node.querySelector('[data-sn-wish-compare]');
            if (v && v.compare_at_price > v.price) { compare.textContent = money(v.compare_at_price, format); compare.hidden = false; }
            node.querySelector('[data-sn-wish-date]').textContent = row.t ? new Date(row.t).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' }) : '—';
            var status = node.querySelector('[data-sn-wish-status]');
            status.textContent = p.available ? 'In Stock' : 'Sold Out';
            status.classList.toggle('is-out', !p.available);
            var add = node.querySelector('[data-sn-wish-add]');
            var label = node.querySelector('[data-sn-wish-add-label]');
            if (!p.available) { add.disabled = true; label.textContent = 'Sold Out'; }
            else if (variants.length > 1) { add.setAttribute('data-href', url); label.textContent = optionsLabel; }
            else { add.setAttribute('data-variant', v.id); label.textContent = addLabel; }
            add.setAttribute('aria-label', label.textContent + ' — ' + names[0]);
            var rm = node.querySelector('[data-sn-wish-remove]');
            if (shared) rm.remove();
            else rm.setAttribute('aria-label', 'Remove ' + names[0] + ' from wishlist');
            list.appendChild(node);
          });
          shareInput.value = el.getAttribute('data-share-base') + '?items=' + rows.map(function (r) { return r.h; }).join(',');
          total.textContent = rows.length + (rows.length === 1 ? ' piece saved' : ' pieces saved');
          clearBtn.hidden = !!shared;
        }

        function addToCart(ids) {
          var actions = window.Shopify && window.Shopify.actions;
          if (actions && typeof actions.updateCart === 'function') {
            return actions.updateCart({ lines: ids.map(function (id) { return { merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: 1 }; }) })
              .then(function (res) {
                if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
                var n = res && res.cart && res.cart.totalQuantity;
                if (typeof n === 'number') setCartCount(n);
                if (typeof actions.openCart === 'function') actions.openCart();
              });
          }
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
          })
            .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart.'); }); })
            .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { setCartCount(c.item_count); }); });
        }
        function busy(btn, on) { btn.classList.toggle('is-loading', on); btn.setAttribute('aria-busy', String(on)); }
        function flash(btn, text) {
          var span = btn.querySelector('span');
          var before = span.textContent;
          span.textContent = text;
          btn.classList.add('is-added');
          setTimeout(function () { span.textContent = before; btn.classList.remove('is-added'); }, 1800);
        }

        var clearTimer;
        el.addEventListener('click', function (e) {
          var t = e.target;
          var add = t.closest('[data-sn-wish-add]');
          if (add) {
            if (add.getAttribute('data-href')) { window.location.href = add.getAttribute('data-href'); return; }
            say('');
            busy(add, true);
            addToCart([add.getAttribute('data-variant')])
              .then(function () { flash(add, 'Added'); })
              .catch(function (err) { say(err.message || 'Could not add to cart. Please try again.'); })
              .finally(function () { busy(add, false); });
            return;
          }
          var rm = t.closest('[data-sn-wish-remove]');
          if (rm && W) {
            say('');
            var item = rm.closest('.sn-wish__item');
            var handle = item.getAttribute('data-handle');
            item.classList.add('is-leaving');
            setTimeout(function () { W.remove(handle); }, 200);
            return;
          }
          var all = t.closest('[data-sn-wish-all]');
          if (all) {
            var ready = rows.filter(function (r) { return r.p.available && (r.p.variants || []).length === 1; });
            var skipped = rows.length - ready.length;
            say('');
            if (!ready.length) { say('These pieces need options chosen on their product page, or are sold out.'); return; }
            busy(all, true);
            addToCart(ready.map(function (r) { return r.p.variants[0].id; }))
              .then(function () {
                flash(all, 'All Added');
                if (skipped) say(skipped + (skipped === 1 ? ' piece was' : ' pieces were') + ' not added — choose options on the product page or it is sold out.');
              })
              .catch(function (err) { say(err.message || 'Could not add to cart. Please try again.'); })
              .finally(function () { busy(all, false); });
            return;
          }
          if (t.closest('[data-sn-wish-clear]') && W) {
            if (!clearBtn.classList.contains('is-confirm')) {
              clearBtn.classList.add('is-confirm');
              clearBtn.textContent = 'Tap again to clear';
              clearTimer = setTimeout(function () { clearBtn.classList.remove('is-confirm'); clearBtn.textContent = 'Clear Wishlist'; }, 4000);
              return;
            }
            clearTimeout(clearTimer);
            clearBtn.classList.remove('is-confirm');
            clearBtn.textContent = 'Clear Wishlist';
            say('');
            W.clear();
            return;
          }
          var copy = t.closest('[data-sn-wish-copy]');
          if (copy) {
            var done = function () { copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = 'Copy'; }, 2000); };
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(shareInput.value).then(done, function () { shareInput.select(); try { document.execCommand('copy'); done(); } catch (err) {} });
            } else { shareInput.select(); try { document.execCommand('copy'); done(); } catch (err) {} }
            return;
          }
          if (t.closest('[data-sn-wish-save-all]') && W && shared) {
            W.addMany(shared.slice().reverse());
            shared = null;
            if (window.history.replaceState) window.history.replaceState(null, '', window.location.pathname);
            say('Saved to your wishlist.', true);
            load();
          }
        });
        shareInput.addEventListener('focus', function () { shareInput.select(); });

        document.addEventListener('snout:wishlist', function () { if (!shared) load(); });
        load();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
